import { QuotRepayDto } from "./loanBorrower/quoteRepay";
import { SkipRepayType } from "./loanBorrower/skipRepay";
import { CollectionType } from "./loanBorrower/collectionType";
import { ChargeType } from "./loanBorrower/chargeType";
import { AdjustType } from "./loanBorrower/adjust";
import { InterestService } from "./loanBorrower/interestService";


export class LoanStep2 {
    discount: number = 0;
    interestRate: number;
    tenureMonths: number = 0;
    downpaymentRate: number = 0;
    downpaymentAmount: number = 0;
    dealerId: string;

    repayTypcodeEntityIdDto: {
        repayTypcode: string;
        portfolioId: number;
    };

    quotRepayMapDto: QuotRepayDto;


    skipRepayTypcodeEntityIdDto: SkipRepayType;

    collectionTypcodeEntityIdDto: CollectionType;

    chargeTypcodeEntityIdDto: ChargeType;

    adjustTypcodeEntityIdDto: AdjustType;

    intrServiceTypcodeEntityIdDto: InterestService;

    indusRefId: string = "";

    indQuotationEntityIdDto: {
        quotationId: string;
        portfolioId: number;
    }

    financedAmount: number = 0;

    exShowroomPrice: number;

    basicInstallment: number = 0;

    totalInstallment: number = 0;

    repayVarFlag: number = 0;

    custId: String;

    statusId: String = "";

    assestCost: number;

    newQuotFlag: number; // flag to idnetify the type of car selected

    newVehBrandId: string; // selected bank name

    splpgmId: string;
    productId: string;
    vehModelId: string;
    vehBrandId: string;
    usedVehBrandId: string;

    constructor() {
        this.quotRepayMapDto = new QuotRepayDto();
        this.repayTypcodeEntityIdDto = {
            repayTypcode: '',
            portfolioId: 0
        };
        this.skipRepayTypcodeEntityIdDto = new SkipRepayType();
        this.collectionTypcodeEntityIdDto = new CollectionType();
        this.chargeTypcodeEntityIdDto = new ChargeType();
        this.adjustTypcodeEntityIdDto = new AdjustType();
        this.intrServiceTypcodeEntityIdDto = new InterestService();

        this.indQuotationEntityIdDto = {
            quotationId: "",
            portfolioId: 0
        }
    }
}